import React from 'react';
import Styles from "./NotFound.css";

var NotFound = function NotFound() {
  return React.createElement("div", {
    className: Styles.notFound
  }, React.createElement("span", null, "No results were found."));
};

export default NotFound;